// extracted by mini-css-extract-plugin
module.exports = {"checkbox-color-blue":"_2b2b1","checkboxColorBlue":"_2b2b1"};